/**
 * Check if the current pathname is on the Archie home page
 * @param pathname - The current pathname to check
 * @returns true if on home page or any home sub-page
 */
export function isArchieHome(pathname: string): boolean {
  return pathname === '/home' || pathname.startsWith('/home/')
} 